import React, { Suspense } from 'react';
import { useRoutes } from 'react-router-dom';

import { CenteredMessage } from '@atoms';
import { Layout } from '@organisms';
import { unauthenticatedRoutes, superAdminRoutes, LOCadminRoutes } from '@routes';
import { useAuth, useIsLOCadmin } from '@hooks';

const LoadingPage = () => <CenteredMessage loader>Loading page...</CenteredMessage>;

const LOCadminApp = () => {
  const element = useRoutes(LOCadminRoutes);

  return (
    <Layout>
      <Suspense fallback={<LoadingPage />}>{element}</Suspense>
    </Layout>
  );
};

const AuthenticatedApp = () => {
  const element = useRoutes(superAdminRoutes);

  return (
    <Layout>
      <Suspense fallback={<LoadingPage />}>{element}</Suspense>
    </Layout>
  );
};

const UnauthenticatedApp = () => {
  const element = useRoutes(unauthenticatedRoutes);

  return (
    <Layout>
      <Suspense fallback={<LoadingPage />}>{element}</Suspense>
    </Layout>
  );
};

const App = () => {
  const auth = useAuth();
  const isLOCadmin = useIsLOCadmin();

  if (auth.isFetching)
    return (
      <Layout>
        <CenteredMessage loader>Signing in...</CenteredMessage>
      </Layout>
    );

  if (auth.error) {
    const isUnauthorized = auth.error?.response?.status === 401;
    return (
      <Layout>
        <CenteredMessage loader={isUnauthorized} style={{ whiteSpace: 'pre', textAlign: 'center', lineHeight: 1.2 }}>
          {isUnauthorized ? `Unauthorized\nRedirecting...` : auth.error.message}
        </CenteredMessage>
      </Layout>
    );
  }

  if (!auth.isAuthenticated) return <UnauthenticatedApp />;

  if (isLOCadmin) return <LOCadminApp />;

  return <AuthenticatedApp />;
};

export default App;
